export const UI = {
  tileColor: '#EB6E46',
};
